import moment from 'moment-timezone'
import { OrganizationSubjects } from '@/common/enums/OrganizationSubjects';

/**
 * @member {moment.Moment} minDate Smallest date from which a document can be submitted. Inclusive
 * @member {moment.Moment} maxDate Longest date from which a document can be submitted. Inclusive
 * @member {moment.Moment[]} disabledDates Array of extra excluded dates
 */
export default {
  props: {
    checkForeignVisitors: {
      type: Boolean,
      default: true
    },

    dateValueType: {
      type: String,
      default: 'format'
    },

    dateFormat: {
      type: String,
      default: 'DD.MM.YYYY'
    },

    dateMask: {
      type: String,
      default: '##.##.####'
    },

    disabledDates: {
      type: Array,
      default: () => []
    },

    minDate: {
      default: null
    },

    form: {
      type: Object,
      default: () => ({})
    },

    maxDate: {
      default: null
    },

    timezone: {
      type: String,
      default: 'Europe/Moscow'
    }
  },

  methods: {
    /**
     * @param {Date} date
     * @return {boolean}
     */
    isDisabledDate (date) {
      // The argument is a date in the local machine's time zone and contains
      // the midnight UNIX timestamp for the local time zone date. Changing the
      // time zone can move the date back, but the time zone must be changed for
      // validation. That's why
      const stringDate = moment(date).format('DD.MM.YYYY [00:00:00]')
      const momentDate = moment.tz(stringDate, 'DD.MM.YYYY HH:mm:ss', this.timezone)
      const foreignVisitors = this.form.visitors[0].personal.nationality_id !== 182
      const terminalOrganization = this.form.organization.subject_id === OrganizationSubjects.Terminal

      if (this.disabledDates.find(disabledDate => disabledDate.isSame(date, 'day'))) {
        return true
      }

      if (momentDate.isBefore(this.minDate, 'day')) {
        return true
      }

      if (this.checkForeignVisitors && terminalOrganization && foreignVisitors) {
        return false
      }

      return momentDate.isAfter(this.maxDate, 'day')
    }
  }
}
